fragment PaginatorInfoFragment on PaginatorInfo {
    currentPage
    perPage
    total
    lastPage
    hasMorePages
    firstItem
    lastItem
}